import UIkit from 'uikit';

const initMegamenu = () => {
  const toggleThirdLevelNav = (el) => {
    const megamenu = el.closest('.megamenu');
    if (!megamenu) return;

    const switcherContainers = el.closest('.sub-nav')?.querySelectorAll('.uk-switcher.switcher-container');
    const items = el.closest('.sub-nav')?.querySelectorAll('.uk-switcher.switcher-container > *');
    const defaultQuickLink = el.closest('.sub-nav')?.querySelector('.default-quick-link');
    const dropEl = el.closest('.sub-nav.uk-drop');
    const isSecondLevel = !!el.closest('.second-level-nav');
    const isThirdLevel = !!el.closest('.third-level-nav');

    if (el.classList.contains('megamenu-back-button') && !el.classList.contains('uk-offcanvas-close')) {
      const closestNav = el.closest('.third-level-nav');
      const switcherContainers = closestNav?.querySelectorAll('.uk-switcher.switcher-container');
      const currentActiveSwitchers = Array.from(switcherContainers || []);;
      const currentActiveElements = currentActiveSwitchers.map(switcher => switcher.querySelector('.uk-active'));
      const secondLevelActiveTabs = document.querySelectorAll('.uk-subnav.uk-subnav-pill .uk-active');
      if(isSecondLevel) {
        dropEl?.classList.add('uk-animation-screen-leave');
        setTimeout(() => {
          dropEl?.classList.remove('uk-animation-screen-leave');
          UIkit.drop(dropEl).hide(0);
        }, 200);
      }

      if(isThirdLevel) {
        
        currentActiveElements.forEach(switcher => {
          if(switcher) {
            switcher.classList.add('uk-animation-switcher-leave')
          }
        });
        secondLevelActiveTabs.forEach(tab => {
          
          if(tab) {
            tab.classList.remove('uk-active');
          }
        })

        if(defaultQuickLink) {
          defaultQuickLink.style.display = 'none';
        }

        setTimeout(() => {
          currentActiveElements.forEach(switcher => {
            if(switcher) {
              switcher.classList.remove('uk-animation-switcher-leave')
              switcher.classList.remove('uk-active');
            }
          });

          if(defaultQuickLink) {
            defaultQuickLink?.classList.remove('uk-animation-fade');
            defaultQuickLink.style.display = 'block';
          }
        }, 200);
      }
      return;
    }

    if (el.classList.contains('uk-active')) {
      const activeItems = items && Array.from(items).length ? Array.from(items).filter(item => item.classList.contains('uk-active')) : [];
      
      activeItems.forEach(activeItem => {
        activeItem?.classList.add('uk-animation-fade-leave');
      });

      const hasImageInAnyActive = activeItems.some(item => item?.querySelector('img'));

      if(hasImageInAnyActive) {
        defaultQuickLink?.classList.add('uk-animation-fade');
      }

      setTimeout(() => {
        el.classList.remove('uk-active');
        
        activeItems.forEach(activeItem => {
          activeItem?.classList.remove('uk-animation-fade-leave');
          activeItem?.classList.remove('uk-active');
        });
        

        if (defaultQuickLink && hasImageInAnyActive) {
          defaultQuickLink?.classList.remove('uk-animation-fade');
          defaultQuickLink.style.display = 'block';
        }
      }, 200);
    } else {
      
      if (defaultQuickLink) {
          const tabs = el.closest('.sub-nav')?.querySelectorAll('.uk-subnav > li:not(.noswitch)');

          const index = Array.from(tabs).indexOf(el);
          const targetItem = switcherContainers.length > 1 ? items[index * switcherContainers.length + 1] : items[index];
          
          const hasImageInAnyActive = targetItem?.querySelector('img');

          if (hasImageInAnyActive) {
            defaultQuickLink?.classList.add('uk-animation-fade-leave');
            defaultQuickLink.style.display = 'none';
          }
        
        setTimeout(() => {// Check if any active switcher has an image

          if (hasImageInAnyActive) {
            setTimeout(() => {
              defaultQuickLink?.classList.remove('uk-animation-fade-leave');
            }, 200);
          } else {
            defaultQuickLink.style.display = 'block';
          }
        }, 200);
      }
    }
  };

  // Handle second-level navigation
  document.querySelectorAll('.megamenu .second-level-nav .uk-subnav[uk-switcher] li:not(.noswitch)').forEach(el => {
    el.addEventListener('click', (event) => toggleThirdLevelNav(el, event));
  });

  // Prevent propagation for `noswitch` elements
  document.querySelectorAll('.noswitch').forEach(link => {
    link.addEventListener('click', (event) => event.stopPropagation());
  });
  document.querySelectorAll('.megamenu-link').forEach(el => {
    el.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.matches('.sub-nav.uk-drop.uk-open')) {
      UIkit.drop(e.target).hide(0);
    }
  });

  document.querySelectorAll('.megamenu-trigger').forEach(el => {
    el.addEventListener('click', () => {
      const parent = el.parentElement;
      const parentTab = el.parentElement.parentElement;

      if (!parentTab) return;

      const wrappers = parentTab.querySelectorAll('.new-card__wrapper--image');

      if(wrappers.length > 0) {
        wrappers.forEach(wrapper => {
          if (!wrapper) return;

          if (wrapper.querySelector('img')) return;

          const src = wrapper.dataset.src;
          const srcset = wrapper.dataset.srcset;
          const alt = wrapper.dataset.alt;

          if (src) {
            const img = document.createElement('img');
            img.src = src;
            if (srcset) img.srcset = srcset;
            if (alt) img.alt = alt;

            wrapper.appendChild(img);
          }
        });
      }

      const currentDropNav = parent.nextElementSibling;
      if (!currentDropNav) return;

      const secondLevelNav = currentDropNav.querySelector('.second-level-nav');
      const switcherElements = currentDropNav.querySelectorAll('.uk-switcher');
      const defaultQuickLink = currentDropNav.querySelector('.default-quick-link');

      secondLevelNav?.querySelectorAll('.uk-active').forEach(activeEl => {
        activeEl.classList.remove('uk-active');
      });
      switcherElements?.forEach(switcherEl => {
        switcherEl?.querySelector('.uk-active')?.classList.remove('uk-active');
      });
      if (defaultQuickLink) {
        defaultQuickLink.style.display = 'block';
      }
    });
  });

  // Handle megamenu back button clicks
  document.querySelectorAll('.megamenu-back-button:not(.uk-offcanvas-close)').forEach(el => {
    el.addEventListener('click', () => toggleThirdLevelNav(el));
  });

  // document.addEventListener('click', (e) => {
  //   const header = document.querySelector('header');
  //   const navbar = document.querySelector('.links-wrapper-container');

  //   if (!header.contains(e.target) && !navbar.contains(e.target)) {
  //     UIkit.toggle(navbar, {
  //       animation: 'uk-animation-slide-right',
  //     }).toggle();
  //   }
  // });
};

export default initMegamenu;
